
<div>
  <player-search @select="selectPlayer" />

  <line-separator>OR</line-separator>

  <select-input
    v-model="indexId"
    label="Choose an index"
    searchable
    :options="indexOptions"
    @input="selectIndex"
  />
</div>
